import { PortalBalanceFragment } from "@dashboard/graphql";
import { Box, Text } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

import { portalMessages as m } from "./messages";
import { formatMinutes } from "./utils";

/** Missing time and excess time side by side: they never offset each other. */
export const BalanceView = ({ balance }: { balance: PortalBalanceFragment }) => {
  const intl = useIntl();
  const items: Array<[string, string, string?]> = [
    [
      intl.formatMessage(m.missing),
      formatMinutes(balance.missingMinutes),
      intl.formatMessage(m.missingDays, { days: balance.missingDaysEquivalent }),
    ],
    [intl.formatMessage(m.unclassified), formatMinutes(balance.unclassifiedMissingMinutes)],
    [intl.formatMessage(m.justified), formatMinutes(balance.justifiedMinutes)],
    [intl.formatMessage(m.unjustified), formatMinutes(balance.unjustifiedMinutes)],
    [intl.formatMessage(m.compensated), formatMinutes(balance.compensatedMinutes)],
    [
      intl.formatMessage(m.tolerated),
      formatMinutes(balance.toleratedMinutes),
      balance.toleranceOverCapMinutes
        ? intl.formatMessage(m.overCap, { minutes: balance.toleranceOverCapMinutes })
        : undefined,
    ],
    [intl.formatMessage(m.approvedOvertime), formatMinutes(balance.approvedOvertimeMinutes)],
    [intl.formatMessage(m.compensationWork), formatMinutes(balance.compensationWorkMinutes)],
    [intl.formatMessage(m.unauthorizedStay), formatMinutes(balance.unauthorizedStayMinutes)],
    [intl.formatMessage(m.mealAllowanceDays), String(balance.mealAllowanceDays)],
  ];

  return (
    <Box display="grid" gap={3} __gridTemplateColumns="repeat(auto-fit, minmax(140px, 1fr))">
      {items.map(([label, value, hint]) => (
        <Box key={label} display="flex" flexDirection="column">
          <Text size={2} color="default2">
            {label}
          </Text>
          <Text size={5} fontWeight="bold">
            {value}
          </Text>
          {hint && (
            <Text size={1} color="default2">
              {hint}
            </Text>
          )}
        </Box>
      ))}
    </Box>
  );
};
